import { createSlice } from '@reduxjs/toolkit';

import { getReviews, getReviewsByStudentId } from './actions';

const initialState = {
  data: [] as any[],
  currentPage: 1,
  totalPages: null as any,
  perPage: 50,
};

const reviewsSlice = createSlice({
  name: 'reviews',
  initialState,
  reducers: {},
  extraReducers: (builder: any) => {
    builder.addCase(getReviews.fulfilled, (_: any, action: any) => {
      return action.payload;
    });

    builder.addCase(getReviewsByStudentId.fulfilled, (_: any, action: any) => {
      return action.payload;
    });
  },
});

export default reviewsSlice.reducer;
